import { render, staticRenderFns } from "./design.vue?vue&type=template&id=82e0cf5a&scoped=true"
import script from "./design.vue?vue&type=script&lang=js"
export * from "./design.vue?vue&type=script&lang=js"
import style0 from "./design.vue?vue&type=style&index=0&id=82e0cf5a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e0cf5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82e0cf5a')) {
      api.createRecord('82e0cf5a', component.options)
    } else {
      api.reload('82e0cf5a', component.options)
    }
    module.hot.accept("./design.vue?vue&type=template&id=82e0cf5a&scoped=true", function () {
      api.rerender('82e0cf5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/crud/design.vue"
export default component.exports